import { LabelMessageStatus } from '../../models/label.model';
import { ContentCoverageFilters } from 'models/personalization.model';

const personalizationKeys = {
    formulas: ['unlabeled_formulas'],
    unlabelledVariants: ['unlabelled_variants'],
    personalizationMap: ['personalization-map'],
    getPersonalizationMap: (
        xAxisVariantType?: string,
        yAxisVariantType?: string,
        formulaId?: number,
        formulaStates?: LabelMessageStatus[],
    ) =>
        [
            'personalization-map',
            xAxisVariantType,
            yAxisVariantType,
            formulaId,
            formulaStates,
        ] as string[],
    getContentCoverageMap: (
        xAxisVariantType?: string,
        yAxisVariantType?: string,
        filters: ContentCoverageFilters = {},
    ) =>
        [
            'content-coverage-map',
            xAxisVariantType,
            yAxisVariantType,
            Object.values(filters),
        ] as string[],
    getFormulaCoverageMap: (
        xAxisComponentTypeId: string,
        yAxisComponentTypeId: string,
        labelIdX: number,
        labelIdY: number,
        filters: ContentCoverageFilters = {},
    ) => [
        'formula-coverage-map',
        xAxisComponentTypeId,
        yAxisComponentTypeId,
        labelIdX,
        labelIdY,
        ...Object.entries(filters).flatMap(([key, value]) =>
            Array.isArray(value) ? [key, ...value] : [key, value ?? null],
        ),
    ],
    getHeroRecommendations: (
        limit = 10,
        xAxisComponentTypeId?: string,
        yAxisComponentTypeId?: string,
    ) => [
        'hero-recommendations',
        limit,
        xAxisComponentTypeId,
        yAxisComponentTypeId,
    ],
};

export default personalizationKeys;
